import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setIsLoading, setTheme } from "../slices/configSlice";

function isColor(strColor) {
  var s = new Option().style;
  s.color = strColor;
  return s.color !== "";
}

function useConfig() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.config.isLoading);
  const theme = useSelector((state) => state.config.theme);

  const onThemeChange = useCallback(
    (selectedTheme = {}) => {
      try {
        dispatch(setIsLoading(true));
        // console.log("selectedTheme", selectedTheme);

        const { colorCode = {}, themeConfig = {} } = selectedTheme;
        const { defaultColor, buttonBG, buttonText, code, paginateBg, sidebarMenu, subSidebarMenu, tabHighlight } = themeConfig;

        if (paginateBg &&
          sidebarMenu &&
          subSidebarMenu &&
          tabHighlight) {
          const root = document.querySelector(":root");
          // root.style.setProperty("--primary-color", 'defaultColor');
          // root.style.setProperty("--button-color", `linear-gradient(to right,${colorCode2} , ${defaultColor})`);
          // root.style.setProperty("--button-color-revert", `linear-gradient(to right,${defaultColor} , ${colorCode2})`);
          // console.log("here", defaultColor, colorCode2, root.style);
          // --button-color: linear-gradient(to right,#ff4d4f , #fadb14);
          // --button-color-revert: linear-gradient(to right, #fadb14, #ff4d4f);

          root.style.setProperty("--sidebar-menu-color", sidebarMenu);
          root.style.setProperty("--sidebar-sub-menu-color", subSidebarMenu);
          root.style.setProperty("--table-paginate-color", paginateBg);
          root.style.setProperty("--tab-color", tabHighlight);
          root.style.setProperty("--button-color", buttonBG);

          // console.log("Changed theme to:", theme.name);
          // const modifiedTheme = {
          //   token: {
          //     colorPrimary: defaultColor,
          //     buttonColor: `linear-gradient(to right,${defaultColor} , ${colorCode2})`,
          //     buttonColorRevert: `linear-gradient(to right,${colorCode2} , ${defaultColor})`,
          //   },
          // };

          dispatch(setTheme());
        }

      } catch (error) {
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [dispatch]
  );
  return {
    isLoading,
    theme,
    onThemeChange,
  };
}

export default useConfig;
